/*** IMPORTS FROM imports-loader ***/
var $ = require("jquery");
var jQuery = require("jquery");

exports.encrypt = function (self, block) {
  return self._cipher.encryptBlock(block)
}
exports.decrypt = function (self, block) {
  return self._cipher.decryptBlock(block)
}




/*****************
 ** WEBPACK FOOTER
 ** ./~/browserify-aes/modes/ecb.js
 ** module id = 497
 ** module chunks = 0
 **/